import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import "../common/Util.css";
import transportLogo from "../../assets/svg/transport_ic.svg";
// Import SVG icons for menu items
import dashboardActiveIcon from "../../assets/svg/dashboard-active.svg";
import dashboardIcon from "../../assets/svg/dashboard-inactive.svg";
import tripsActiveIcon from "../../assets/svg/trips-active.svg";
import tripsIcon from "../../assets/svg/trips-inactive.svg";
import stopsActiveIcon from "../../assets/svg/stops-active.svg";
import stopsIcon from "../../assets/svg/stops-inactive.svg";
import liveViewActiveIcon from "../../assets/svg/live-view-active.svg";
import liveViewIcon from "../../assets/svg/live-view-inactive.svg";
import tripCostActiveIcon from "../../assets/svg/trip-cost-active.svg";
import tripCostIcon from "../../assets/svg/trip-cost-inactive.svg";
import reportsActiveIcon from "../../assets/svg/report-active.svg";
import reportsIcon from "../../assets/svg/report-inactive.svg";
import milestoneActiveIcon from "../../assets/svg/milestone_active.svg";
import milestoneIcon from "../../assets/svg/milestone_inactive.svg";
import productActiveIcon from "../../assets/svg/products__active_ic.svg";
import productIcon from "../../assets/svg/products__inactive_ic.svg";
import customerActiveIcon from "../../assets/svg/customer_active_ic.svg";
import customerIcon from "../../assets/svg/customer_inactive_ic.svg";
import vendorActiveIcon from "../../assets/svg/vendor_active_ic.svg";
import vendorIcon from "../../assets/svg/vendor_inactive_ic.svg";
import vehicleActiveIcon from "../../assets/svg/vehicle_active_ic.svg";
import vehicleIcon from "../../assets/svg/vehicle_inactive_ic.svg";
import { useGlobal } from "../../GlobalContext.js";
import { getOrgLogoApi } from "./common-api";
/* import setupIcon from "../../assets/svg/setup.svg";
import usersIcon from "../../assets/svg/users.svg";
import documentsIcon from "../../assets/svg/documents.svg";
import helpsupportIcon from "../../assets/svg/help-support.svg"; */

const menuItems = [
  {
    label: "Dashboard",
    permissionName: "Dashboard",
    path: "/dashboard",
    icon: dashboardIcon,
    activeIcon: dashboardActiveIcon,
  },
  {
    label: "Stops",
    permissionName: "Stops",
    path: "/stops",
    icon: stopsIcon,
    activeIcon: stopsActiveIcon,
  },
  {
    label: "Trips",
    permissionName: "Trips",
    path: "/trips",
    icon: tripsIcon,
    activeIcon: tripsActiveIcon,
  },

  {
    label: "Live View",
    permissionName: "Live view",
    path: "/livetrack",
    icon: liveViewIcon,
    activeIcon: liveViewActiveIcon,
  },
  {
    label: "Trip Cost",
    permissionName: "Trip cost",
    path: "/trip-cost",
    icon: tripCostIcon,
    activeIcon: tripCostActiveIcon,
  },
  {
    label: "Reports",
    permissionName: "Report",
    path: "/reports",
    icon: reportsIcon,
    activeIcon: reportsActiveIcon,
  },
];
const bottomMenuItems = [
  {
    label: "Milestone",
    permissionName: "Milestone",
    path: "/milestones",
    icon: milestoneIcon,
    activeIcon: milestoneActiveIcon,
  },
  {
    label: "Product",
    permissionName: "Product",
    path: "/products",
    icon: productIcon,
    activeIcon: productActiveIcon,
  },
  {
    label: "Customer",
    permissionName: "Customer",
    path: "/customers",
    icon: customerIcon,
    activeIcon: customerActiveIcon,
  },
  {
    label: "Vendor",
    permissionName: "Vendor",
    path: "/vendor",
    icon: vendorIcon,
    activeIcon: vendorActiveIcon,
  },
  {
    label: "Vehicle",
    permissionName: "Vehicle",
    path: "/vehicles",
    icon: vehicleIcon,
    activeIcon: vehicleActiveIcon,
  },
];

export default function Sidebar({ currentfile }) {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [orgLogo, setOrgLogo] = useState(null);

  const { rolePermissionList, userType } = useGlobal();

  useEffect(() => {
    const fetchOrgLogo = async () => {
      try {
        const response = await getOrgLogoApi();
        if (response?.success && response?.image) {
          setOrgLogo(response?.image);
        }
      } catch (error) {
        console.error("Error fetching org logo:", error);
      }
    };
    fetchOrgLogo();
  }, []);

  function checkPermission(menuName, permission) {
    return rolePermissionList.findIndex((element) => element["name"] === menuName && element["menu_permission"] === true && element[permission] === true) > -1 ? true : false;
  }
  return (
    <div
      style={{
        width: isCollapsed ? "80px" : "280px",
        minWidth: isCollapsed ? "80px" : "280px",
        maxWidth: isCollapsed ? "80px" : "280px",
        transition: "width 0.3s ease-in-out, min-width 0.3s ease-in-out, max-width 0.3s ease-in-out",
        willChange: "width",
        display: "flex",
        flexDirection: "column",
        padding: isCollapsed ? "12px 0" : "20px",
        borderRight: "1px solid #E5E5E5",
        position: "relative",
        overflow: "hidden",
      }}
      className="sidebar bg-white vh-100 scroll-hidden"
    >
      <div className="d-flex align-items-center justify-content-center mb-3">
        <img
          src={orgLogo || transportLogo}
          alt="Logo"
          style={{
            maxWidth: "60px",
            maxHeight: "60px",
            objectFit: "contain",
          }}
        />
      </div>
      {/* Header with Menu Label and Toggle */}
      {/*  <div className="d-flex align-items-center justify-content-between mb-4 flex-grow-1">
        {!isCollapsed && (
          <h6
            className="fw-bold m-0"
            style={{ fontSize: "14px", color: "#1F2937" }}
          >
            MENU
          </h6>
        )}
        <button
          onClick={() => setIsCollapsed(!isCollapsed)}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M3 5h14M3 10h14M3 15h14" />
          </svg>
        </button>
      </div> */}
      <div className="fs-11 fw-600 text-center" style={{ color: "#8790A1" }}>
        MENU
      </div>
      {/* Main Menu Items */}
      <ul className="list-unstyled flex-grow-1" style={{ margin: 0, padding: 0 }}>
        {menuItems
          .filter((item) => rolePermissionList.some((el) => el.name === item.permissionName && el["menu_permission"] === true))
          .map((item) => {
            const isActive = currentfile === item.label;
            return (
              <li key={item.path} className="mb-2" style={{ listStyle: "none" }}>
                <NavLink
                  to={item.path}
                  className="d-flex align-items-center gap-2 p-2 rounded-2 fs-13 fw-500 text-decoration-none text-dark"
                  style={{
                    justifyContent: isCollapsed ? "center" : "flex-start",
                    transition: "background-color 0.2s ease-in-out",
                    transform: "translateZ(0)",
                    backfaceVisibility: "hidden",
                    WebkitFontSmoothing: "antialiased",
                    backgroundColor: isActive ? "#E0E7FF" : "transparent",
                  }}
                  title={isCollapsed ? item.label : ""}
                  onMouseEnter={(e) => {
                    if (!isActive) {
                      e.currentTarget.style.backgroundColor = "#F3F4F6";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!isActive) {
                      e.currentTarget.style.backgroundColor = "transparent";
                    } else {
                      e.currentTarget.style.backgroundColor = "#E0E7FF";
                    }
                  }}
                >
                  <div
                    className={`${isActive ? "selected-menu" : ""}`}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                      width: "20px",
                      height: "20px",
                    }}
                  >
                    <img
                      src={isActive ? item.activeIcon : item.icon}
                      alt={`${item.label} icon`}
                      style={{
                        width: "20px",
                        height: "20px",
                        objectFit: "contain",
                        display: "block",
                      }}
                    />
                  </div>
                  {!isCollapsed && (
                    <span
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {item.label}
                    </span>
                  )}
                </NavLink>
              </li>
            );
          })}
      </ul>

      {/* Divider */}
      <hr style={{ margin: "16px 0", opacity: 0.2 }} />
      <div className="fs-11 fw-600 text-center" style={{ color: "#8790A1" }}>
        SETUP
      </div>
      {/* Bottom Menu Items */}
      <ul className="list-unstyled" style={{ margin: 0, padding: 0 }}>
        {bottomMenuItems
          .filter((item) => rolePermissionList.some((el) => el.name === item.permissionName && el["menu_permission"] === true))
          .map((item) => {
            const isActive = currentfile === item.label;
            return (
              <li key={item.path} className="mb-2" style={{ listStyle: "none" }}>
                <NavLink
                  to={item.path}
                  className="d-flex align-items-center gap-2 p-2 rounded-2 fs-13 fw-500 text-decoration-none text-dark"
                  style={{
                    justifyContent: isCollapsed ? "center" : "flex-start",
                    transition: "background-color 0.2s ease-in-out",
                    transform: "translateZ(0)",
                    backfaceVisibility: "hidden",
                    WebkitFontSmoothing: "antialiased",
                    backgroundColor: isActive ? "#E0E7FF" : "transparent",
                  }}
                  title={isCollapsed ? item.label : ""}
                  onMouseEnter={(e) => {
                    if (!isActive) {
                      e.currentTarget.style.backgroundColor = "#F3F4F6";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!isActive) {
                      e.currentTarget.style.backgroundColor = "transparent";
                    } else {
                      e.currentTarget.style.backgroundColor = "#E0E7FF";
                    }
                  }}
                >
                  <div
                    className={`${isActive ? "selected-menu" : ""}`}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                      width: "20px",
                      height: "20px",
                    }}
                  >
                    <img
                      src={isActive ? item.activeIcon : item.icon}
                      alt={`${item.label} icon`}
                      style={{
                        width: "20px",
                        height: "20px",
                        objectFit: "contain",
                        display: "block",
                      }}
                    />
                  </div>
                  {!isCollapsed && (
                    <span
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {item.label}
                    </span>
                  )}
                </NavLink>
              </li>
            );
          })}
      </ul>

      {/* User Profile Section at Bottom */}
      {!isCollapsed && (
        <div
          className="mt-4 p-2 rounded-2"
          style={{
            backgroundColor: "#F3F4F6",
            textAlign: "center",
          }}
        >
          <div
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              backgroundColor: "#6366F1",
              color: "white",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 8px",
              fontWeight: "bold",
              fontSize: "16px",
            }}
          >
            U
          </div>
          <p style={{ margin: "0", fontSize: "12px", fontWeight: "500" }}>User Profile</p>
          <p
            style={{
              margin: "0",
              fontSize: "11px",
              color: "#6B7280",
            }}
          >
            View Account
          </p>
        </div>
      )}
    </div>
  );
}
